<template>
  <div >
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">交易系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>财务对账</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="top">
      <el-form label-width="100px" :label-position="'right'">
        <el-form-item label="日期:">
          <el-date-picker
              v-model="dateBuffer"
              type="datetimerange"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="输入币:">
          <el-input v-model="coins" placeholder="输入币,一次只输入一个币种" clearable></el-input>
        </el-form-item>
        <el-form-item label="输入用户ID:">
          <el-input v-model="userIds" placeholder="输入用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryData()">查询</el-button>
        </el-form-item>
      </el-form>
      <div id="chartLineBox" style="width: 90%;height: 70vh; margin: 40px 0 40px 0"> </div>
      <div style="text-align:right">
        <el-button v-if="tableData" type="success" plain @click="exportExcel()">导出excel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import utils from "./utils";
import axios from 'axios'
import moment from "moment";

const columns = [{title: {title:'交易对', key:'market'},key:'symbol'}]
const tableData = [
  {
    symbol:'eth_btc',
    toHedgeNum: '25',
    notLossAveragePrice: '1253.6',
    market:'1175.6',
    hedgedNum:'56',
    averagePrice: '1253.8',
    remainHedgeNum:'14',
    hedgingProfit:'1234',
    floatProfit:'234',
    fixedProfit:'123',
    finalProfit:'532'
  },
]
const pickerOptions = {
  shortcuts: [
    {
      text: '最近一天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近三天',
      onClick(picker) {
        const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一周',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近两个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);picker.$emit('pick', [start, end]);}
    }
  ]
}
const pickerOptions1 =  {
  shortcuts: [
    {
      text: "最近一天",
      onClick(picker) {picker.$emit("pick", [moment().subtract(1, "day").startOf("day").toDate(), moment().endOf("day").toDate(),]);},
    },
    {
      text: "最近三天",
      onClick(picker) {picker.$emit("pick", [moment().subtract(3, "day").startOf("day").toDate(), moment().endOf("day").toDate(),]);},
    },
    {
      text: "最近一周",
      onClick(picker) {picker.$emit("pick", [moment().subtract(7, "day").startOf("day").toDate(), moment().endOf("day").toDate(),]);},
    },
    {
      text: "最近一个月",
      onClick(picker) {picker.$emit("pick", [moment().subtract(30, "day").startOf("day").toDate(), moment().endOf("day").toDate(),]);},
    },
    {
      text: "最近两个月",
      onClick(picker) {picker.$emit("pick", [moment().subtract(60, "day").startOf("day").toDate(), moment().endOf("day").toDate(),]);},
    },
  ]
}

export default {
  data() {
    return {
      coins:'',
      userIds:'',
      dateBuffer:'',
      columns:columns,
      tableData:tableData,
      pickerOptions: pickerOptions1,
    }
  },
  methods:{
    exportExcel(){
      utils.export2Excel(this.columns, this.tableData)
    },
    queryData(){
      if(!this.dateBuffer){
        this.$message({showClose: true, message: '请选择日期', type: 'error'});
        return
      }
      const now = new Date().getTime();
      const start = this.dateBuffer[0];
      const endStamp = new Date(this.dateBuffer[1]).getTime();
      const startStamp = new Date(start).getTime();
      if (startStamp > now){
        this.$message({showClose: true, message: '时间选择错误，开始时间不合理', type: 'error'});
        return
      }
      if (endStamp > now){
        this.params.endTime = now
      }
      if (!this.coins){
        this.$message({showClose: true, message: '请输入需要查询的交易对', type: 'error'});
        return
      }
      if (!this.userIds){
        this.$message({showClose: true, message: '请输入用户ID', type: 'error'});
        return
      }
      utils.queryAccountReconciliation(this.params).then((response)=>{
        let series = response.data.series;
        let newSeries = series.filter((item)=>{
          this.$set(item, 'type', 'line')
          this.$set(item, 'markPoint', {data: [{type: 'max', name: '最大值'}, {type: 'min', name: '最小值'}]})
          this.$set(item, 'markLine', {data: [{type: 'average', name: '平均值'}]})
          return item
        })
        utils.drawLineBox('chartLineBox', newSeries, response.data.xAxis)
      })
    },
  },
  computed:{
    params(){
      return {
        coins:this.coins,
        userIds: this.userIds,
        startTime:new Date(this.dateBuffer[0]).getTime(),
        endTime:new Date(this.dateBuffer[1]).getTime()
      };
    }
  }
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.top{
  margin: 30px 15px 30px 15px;
  padding: 20px 5px 20px 5px;
  background-color: white;
}
</style>